import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Product extends Component {
  // state = {};

  render() {
    this.currencyOptions = {
      style: 'currency',
      currency: 'PLN',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };
    const { emoji, name, price, updateCart, reactKey } = this.props;

    const addProduct = (e) => {
      // qty
      const productCont = e.target.closest('.product');
      const quantitySpan = productCont.querySelector('.qty');
      let quantity = Number(quantitySpan.textContent);
      quantity += 1;
      quantitySpan.textContent = String(quantity);

      // single item price
      const { itemprice } = productCont.querySelector('.itemPrice').dataset;

      // totalPrice
      const stackPriceSpan = e.target
        .closest('.product')
        .querySelector('.stackPrice');
      const stackPrice = itemprice * quantity;
      stackPriceSpan.textContent = stackPrice.toLocaleString(
        undefined,
        this.currencyOptions
      );

      // update top panel
      updateCart(name, quantity, itemprice, 'add');
    };
    const removeProduct = (e) => {
      // reset qty
      const productCont = e.target.closest('.product');
      const quantitySpan = productCont.querySelector('.qty');
      quantitySpan.textContent = 0;

      // reset totalPrice
      const stackPriceSpan = e.target
        .closest('.product')
        .querySelector('.stackPrice');
      stackPriceSpan.textContent = 0;

      // update top panel
      updateCart(name, undefined, undefined, 'remove');
    };

    return (
      <div className="product" key={reactKey}>
        <div className="product-qty">
          Qty: <span className="qty">0</span>
        </div>
        <div className="product-stackPrice">
          Total Price: <span className="stackPrice">0</span>
        </div>
        <div role="img" aria-label="ice cream">
          <span className="emoji">{emoji}</span>
          <div className="itemInfo">
            <span className="itemPrice" data-itemprice={price}>
              {price.toLocaleString(undefined, this.currencyOptions)}
            </span>
          </div>
        </div>
        <div className="buttons">
          <button onClick={addProduct} type="button">
            Add
          </button>
          <button type="button" onClick={removeProduct}>
            Remove
          </button>
        </div>
      </div>
    );
  }
}

Product.propTypes = {
  emoji: PropTypes.string,
  name: PropTypes.string,
  price: PropTypes.number,
  reactKey: PropTypes.number,
  updateCart: PropTypes.func,
};

export default Product;
